// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BlockedBusinessesViewOpenEvent
 */
export var BlockedBusinessesViewOpen = function (_a) {
    var customerToken = _a.customerToken;
    return ({
        name: "BlockedBusinesses View Open",
        parameters: {
            cdf_entity: "BlockedBusinesses",
            cdf_action: "View",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BlockedBusinessesTapBlockEvent
 */
export var BlockedBusinessesTapBlock = function (_a) {
    var customerToken = _a.customerToken;
    return ({
        name: "BlockedBusinesses Tap Block",
        parameters: {
            cdf_entity: "BlockedBusinesses",
            cdf_action: "Tap",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BlockedBusinessesTapUnblockEvent
 */
export var BlockedBusinessesTapUnblock = function (_a) {
    var customerToken = _a.customerToken, merchantToken = _a.merchantToken;
    return ({
        name: "BlockedBusinesses Tap Unblock",
        parameters: {
            cdf_entity: "BlockedBusinesses",
            cdf_action: "Tap",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BlockedBusinessesTapNavigationHelpEvent
 */
export var BlockedBusinessesTapNavigationHelp = function (_a) {
    var customerToken = _a.customerToken;
    return ({
        name: "BlockedBusinesses Tap NavigationHelp",
        parameters: {
            cdf_entity: "BlockedBusinesses",
            cdf_action: "Tap",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
